<template>
  <div v-if="$store.state.cart.items.length">
    <div v-if="open" class="gc-cart-scrim" @click="close"></div>

    <div class="gc-cart-dock">
      <section v-if="open" class="gc-cart-sheet">
        <header class="gc-cart-head">
          <div>
            <h2>Your Cart ({{ count }})</h2>
            <p>Modify your current cart</p>
          </div>
          <button type="button" class="gc-cart-close" aria-label="Close cart" @click="close">
            <v-icon size="18">mdi-close</v-icon>
          </button>
        </header>

        <div class="gc-cart-items">
          <article v-for="item in $store.state.cart.items" :key="item._id" class="gc-cart-line">
            <div class="gc-cart-line-copy">
              <p class="gc-cart-name">{{ item.name }}</p>
              <p class="gc-cart-price">
                <b>{{ getPrice(item) | fc }}</b>
                <span>/ {{ item.size }}{{ item.unit }}</span>
              </p>
              <p v-if="store.applyTax && store.taxType === 'product' && item.gst" class="gc-cart-tax">
                Price Breakup: <b>{{ beforeTaxTotal(item) | fc }}</b> + Tax ({{ item.gst }}%)
                <b>{{ totalItemTax(item) | fc }}</b>
              </p>
            </div>
            <ProductItemQtyHandler
              :small="true"
              :is-cart="true"
              :product="item"
              :no-elevation="true"
            ></ProductItemQtyHandler>
          </article>
        </div>
      </section>

      <div class="gc-cart-bar">
        <v-progress-linear
          v-if="$store.state.cart.updating"
          class="gc-cart-progress"
          indeterminate
          height="3"
          color="primary"
        ></v-progress-linear>

        <button type="button" class="gc-cart-summary" @click="toggle">
          <b>{{ cartTotal | fc }}</b>
          <span>{{ count }} item{{ count === 1 ? "" : "s" }}</span>
        </button>

        <button
          type="button"
          class="gc-cart-expand"
          :aria-label="open ? 'Hide cart items' : 'Show cart items'"
          @click="toggle"
        >
          <v-icon>{{ open ? "mdi-chevron-down" : "mdi-chevron-up" }}</v-icon>
        </button>

        <router-link class="gc-cart-checkout" to="/checkout/cart">Checkout</router-link>
      </div>
    </div>
  </div>
</template>
<script>
import Cart from "../../services/cart";
export default {
  name: "CartFooter",

  methods: {
    toggle() {
      const next = !this.open;
      this.expanded = next;
      this.$store.state.cart.expanded = next;
    },

    close() {
      this.expanded = false;
      this.$store.state.cart.expanded = false;
    },

    getPrice(item) {
      return Cart.getPrice(item);
    },

    beforeTaxTotal(item) {
      const cartItem = Cart.findProduct(item);
      return cartItem.beforeTaxPrice * cartItem.qty;
    },

    totalItemTax(item) {
      const cartItem = Cart.findProduct(item);
      const amount = cartItem.beforeTaxPrice * cartItem.qty;
      return this.calculateTax(amount, cartItem.gst);
    },

    calculateTax(amount, tax) {
      let taxAmount = 0;
      if (amount && tax) taxAmount = parseFloat(((amount * tax) / 100).toFixed(2));
      return taxAmount;
    },
  },

  computed: {
    open() {
      return this.expanded || this.$store.state.cart.expanded;
    },

    count() {
      return this.$store.state.cart.items.length;
    },

    cartTotal() {
      return Cart.getTotal();
    },

    store() {
      return this.$store.state.storeInfo;
    },
  },

  data() {
    return {
      expanded: false,
    };
  },
};
</script>

<style>
.gc-cart-scrim {
  position: fixed;
  inset: 0;
  z-index: 39;
  background: rgba(28, 36, 48, 0.32);
}

.gc-cart-dock {
  position: fixed;
  z-index: 40;
  left: 50%;
  bottom: max(12px, env(safe-area-inset-bottom));
  width: min(560px, calc(100% - 24px));
  transform: translateX(-50%);
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.gc-cart-bar {
  position: relative;
  display: flex;
  align-items: center;
  gap: 8px;
  min-height: 64px;
  padding: 8px 8px 8px 18px;
  overflow: hidden;
  background: #fff;
  border: 1px solid #e6e8ee;
  border-radius: 16px;
  box-shadow: 0 12px 32px rgba(28, 36, 48, 0.18);
}

.gc-cart-progress {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
}

.gc-cart-summary {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 0;
  border: 0;
  background: transparent;
  color: #1c2430;
  font: inherit;
  text-align: left;
  cursor: pointer;
}

.gc-cart-summary b {
  font-size: 1.05rem;
  line-height: 1.2;
}

.gc-cart-summary span {
  color: #5c6570;
  font-size: 0.82rem;
  font-weight: 500;
}

.gc-cart-expand {
  flex: 0 0 auto;
  width: 40px;
  height: 40px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 0;
  border-radius: 12px;
  background: #f3f4f6;
  color: #1c2430;
  cursor: pointer;
}

.gc-cart-expand:focus-visible,
.gc-cart-summary:focus-visible,
.gc-cart-close:focus-visible,
.gc-cart-checkout:focus-visible {
  outline: 2px solid var(--primary, #007bff);
  outline-offset: 2px;
}

.v-application a.gc-cart-checkout {
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 44px;
  min-width: 112px;
  padding: 0 18px;
  border-radius: 999px;
  background: var(--primary, #007bff);
  color: #fff !important;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1;
  text-decoration: none;
  white-space: nowrap;
}

.v-application a.gc-cart-checkout:hover {
  color: #fff !important;
  filter: brightness(0.94);
}

.gc-cart-checkout:active,
.gc-cart-expand:active,
.gc-cart-close:active {
  transform: translateY(1px);
}

.gc-cart-sheet {
  display: flex;
  flex-direction: column;
  max-height: min(52vh, 420px);
  overflow: hidden;
  background: #fff;
  border: 1px solid #e6e8ee;
  border-radius: 16px;
  box-shadow: 0 16px 40px rgba(28, 36, 48, 0.16);
}

.gc-cart-head {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 14px 12px 16px;
  border-bottom: 1px solid #e6e8ee;
}

.gc-cart-head h2 {
  margin: 0;
  font-size: 1.05rem;
  font-weight: 600;
  line-height: 1.2;
}

.gc-cart-head p {
  margin: 2px 0 0;
  color: #5c6570;
  font-size: 0.82rem;
}

.gc-cart-close {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  display: grid;
  place-items: center;
  padding: 0;
  border: 1px solid #e6e8ee;
  border-radius: 999px;
  background: #fff;
  color: #1c2430;
  cursor: pointer;
}

.gc-cart-items {
  overflow: auto;
  padding: 0 16px 8px;
}

.gc-cart-line {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 12px 0;
  border-bottom: 1px solid #eef0f3;
}

.gc-cart-line:last-child {
  border-bottom: 0;
}

.gc-cart-line-copy {
  min-width: 0;
  flex: 1 1 auto;
}

.gc-cart-line > .row {
  flex: 0 0 auto;
  width: auto;
  margin: 0 0 0 auto;
  justify-content: flex-end;
}

.gc-cart-line > .row > .col {
  flex: 0 0 auto;
  width: auto;
  max-width: none;
  padding: 0;
}

.gc-cart-name {
  margin: 0 0 4px;
  font-weight: 600;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.gc-cart-price,
.gc-cart-tax {
  margin: 0;
  font-size: 0.9rem;
  line-height: 1.4;
}

.gc-cart-price b {
  color: var(--primary, #007bff);
}

.gc-cart-price span,
.gc-cart-tax {
  color: #5c6570;
}

@media (prefers-reduced-motion: no-preference) {
  .gc-cart-sheet {
    animation: gc-cart-in 0.28s cubic-bezier(0.16, 1, 0.3, 1);
  }
}

@keyframes gc-cart-in {
  from {
    opacity: 0;
    transform: translateY(8px);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
</style>
